import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

const Payment = ({ data }) => {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col flex-wrap gap-5 shadow-lg p-10 w-full box-border justify-between">
      <h2 className="text-sm md:text-base font-bold">Fortjeneste</h2>
      <div className="flex flex-col gap-y-5 justify-between h-full flex-[1]">
        <div className="gap-y-5 flex flex-col">
          <div className="font-normal">
            <div className="flex border-box">
              <p className="grow">Ordre</p>
              <p>{(Number(data.products.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
            </div>
            <div className="flex border-box">
              <p className="grow">Gebyr</p>
              <p>- {((Number(data.products.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100) * 0.05).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
            </div>
          </div>
          <div className="">
            <div className="flex border-box font-semibold">
              <p className="grow">{data.status === 3 ? "Overført" : "Overføres"} til saldo</p>
              <p>{((Number(data.products.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100)-((Number(data.products.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100) * 0.05)).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
            </div>
            {data.status === 3 ? <h2 className="ml-auto w-fit"><span className="underline text-emerald-600 cursor-pointer" onClick={() => navigate('/dashboard/saldo')}>Se saldo</span></h2> : ""}
          </div>
        </div>
        {data.status !== 3 ? 
          <div className="w-full p-5 ring-1 ring-orange-600">
            <p className="text-sm"><span className="font-semibold">BEMÆRK!</span> Beløbet overføres først til din saldo, når køber har modtaget samt godkendt indholdet af pakken.</p>
          </div>
        :
          <div className="w-full p-5 ring-1 ring-emerald-600">
            <p className="text-sm">Ordren er afsluttet og pengene kan udbetales til din bankkonto.</p>
          </div>}
      </div>
    </div>
  )
}

export default Payment